import {BASE_URL} from "../../constants";
import formurlencoded from "form-urlencoded";
import FetchHelper from "../FetchHelper";
import {CityOptions, RoleSubRole} from "../JobsPostAd/others/otherFeatures";


export default class UserUtil {
    static updateUserCompanyDetails = userDetails => {
        if (userDetails.vblDetails && userDetails.vblDetails.length > 0) {
            let details = userDetails.vblDetails[0];
            let companyDetails = {
                hiringCompany: '',
                kycCompany: '',
                companyName: '',
                isToDisplayIndividual: true,
                teamType: ''
            };

            if (details.company_name && 'NA' !== details.company_name)
                companyDetails.hiringCompany = details.company_name;

            if (details.team_type)
                companyDetails.teamType = details.team_type;
            
            companyDetails.kycCompany = companyDetails.hiringCompany;
            companyDetails.companyName = companyDetails.hiringCompany;
            
            if (1 === details.company_type && ('FOS' === details.team_type || ('Direct Sales' === details.team_type && (1 === details.vbl || details.amount >= 10000)))) {
                companyDetails.isToDisplayIndividual = false;
            }
                    
            userDetails.companyDetails = companyDetails;
        }

        return userDetails;
    };

  static getUserByMobile = (params) => {
    let url = BASE_URL + '/jobsAjax/getUserByMobile';
    url += `?isRoleSubRoleOptionsRequired=${!RoleSubRole.isOptionsStored()}
      &isCityOptionsRequired=${!CityOptions.isOptionsStored()}&`;
    let paramString = formurlencoded(params);
    let options = {
      url: url + paramString
    };

    let fetchHelper = new FetchHelper();
    let promise = fetchHelper.request('GET', options);
    return promise.then((response) => {
      return response.data;
    });
  }
}



// WEBPACK FOOTER //
// ../q-jobs/src/utils/User/index.js